const colors = {
  scbPurple: '#7631C1',
  darkPurple: '#4B2885',
  statusBarPurple: '#6A2BAE',
  darkOrchid: '#AD339F',
  scbYellow: '#FEAC00',
  fakeWhite: '#F5F3F6',
  outWhite: '#F7F7F7',
  white: '#FFFFFF',
  slipPurple: '#4B2885',
  lightWhite: '#F9F9F9',
  lightPurple: '#CF1E91',
  mossyGreen: '#00603F',
  blue: '#4A90E2',
  lightYellow: '#FFEAA8',
  cherryRed: '#DA2E36',
  notifGreen: '#007554',
  successGreen: '#6FCF97',
  lightGreen: '#00BC50',
  yellow: '#FFC241',
  lightRed: '#F05F61',
  red: '#ED4C4C',
  gray: '#A8A4AC',
  lightGray: '#E9E6EA',
  faintGrey: '#EAE7EC',
  borderGray: '#DBDBDB',
  borderPurple: '#9E3DA5',
  thaiQRBlue: '#00427A',
  black: '#000000',
  tagRed: '#CF1322',
  tagPalered: '#FFF1F0',
  tagLightred: '#FFA39E',
  tagYellow: '#FAAD14',
  tagLightyellow: '#FFE58F',
  tagPaleyellow: '#FFFBE6',
  tagGreen: '#389E0D',
  tagLightgreen: '#B7EB8F',
  tagPalegreen: '#F6FFED',
  selectedFilter: '#FCF4FA',
  grey: '#A0A0A0',
  font: {
    primary: {
      fakeBlack: '#353239',
      darkGray: '#736E78',
      gray: '#959199',
      lightGray: '#C9C6CD'
    },
    messaging: {
      green: '#06BF59',
      lightRed: '#F05F61',
      yellow: '#FEAC00',
      errorRed: '#FF4D4F',
    },
  },
};

export default colors;
